/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · i18n engine
   English is the source of truth (lives in the HTML). Swedish strings
   come from window.TD_I18N (see i18n-sv.js). Missing keys fall back to
   the English already on the page, so nothing ever breaks.

   Language resolution order:
     1. explicit visitor choice saved in localStorage
     2. URL signal — .se → sv, .es → es, .fr → fr, .it → it, .de → de,
        .br/.pt → pt, .ru → ru, .in → hi; ?lang=sv|es|fr|it|de|pt|ru|hi;
        /sv/, /es/, /fr/, /it/, /de/, /pt/, /ru/, /hi/ path
     3. browser language (navigator.language starts with one of the supported codes)
     4. default: English

   When the active language is one of our localized supported ones (not EN),
   the engine injects <meta name="google" content="notranslate"> + a class
   on <html> so browsers don't try to auto-translate our already-translated
   content (which would otherwise cause false-cognate slips like Spanish
   "conservantes" being rendered as English "conservatives"). For EN visitors
   the meta is removed so browser auto-translation into languages we DON'T
   support still works.

   Markup:
     <h1 data-i18n="home.hero.title">No water.</h1>      text/HTML content
     <input data-i18n-attr="placeholder:contact.email">  attribute(s)
   data-i18n-attr is a ; separated list of attr:key pairs.
═════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var STORE_KEY = 'td-lang';
  var SUPPORTED = ['en', 'sv', 'es', 'fr', 'it', 'de', 'pt', 'ru', 'hi'];
  var DEFAULT = 'en';
  var DICT = (window.TD_I18N || {});

  // Trigger label + flag shown on the language dropdown.
  var FLAG_EN = '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="30" fill="#012169"/><path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6"/><path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" stroke-width="2.5"/><path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10"/><path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6"/></svg>';
  var FLAG_SV = '<svg viewBox="0 0 16 10" xmlns="http://www.w3.org/2000/svg"><rect width="16" height="10" fill="#006AA7"/><rect x="5" width="2" height="10" fill="#FECC00"/><rect y="4" width="16" height="2" fill="#FECC00"/></svg>';
  var FLAG_ES = '<svg viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="40" fill="#C60B1E"/><rect y="10" width="60" height="20" fill="#FFC400"/></svg>';
  var FLAG_FR = '<svg viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="40" fill="#0055A4"/><rect x="20" width="20" height="40" fill="#FFFFFF"/><rect x="40" width="20" height="40" fill="#EF4135"/></svg>';
  var FLAG_IT = '<svg viewBox="0 0 60 40" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="40" fill="#009246"/><rect x="20" width="20" height="40" fill="#FFFFFF"/><rect x="40" width="20" height="40" fill="#CE2B37"/></svg>';
  // Germany — horizontal black/red/gold tricolor.
  var FLAG_DE = '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="10" fill="#000000"/><rect y="10" width="60" height="10" fill="#DD0000"/><rect y="20" width="60" height="10" fill="#FFCE00"/></svg>';
  // Brazil — green field, yellow diamond, blue celestial disc. Simplified
  // (no stars/motto) to stay legible at 19×13 dropdown size.
  var FLAG_PT = '<svg viewBox="0 0 60 42" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="42" fill="#009C3B"/><polygon points="30,5 56,21 30,37 4,21" fill="#FFDF00"/><circle cx="30" cy="21" r="8" fill="#002776"/></svg>';
  // Russia — horizontal white/blue/red tricolor.
  var FLAG_RU = '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="10" fill="#FFFFFF"/><rect y="10" width="60" height="10" fill="#0039A6"/><rect y="20" width="60" height="10" fill="#D52B1E"/></svg>';
  // India — saffron/white/green with Ashoka Chakra (simplified to a small
  // navy circle so it reads at thumb size; full 24-spoke wheel is too dense).
  var FLAG_HI = '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="10" fill="#FF9933"/><rect y="10" width="60" height="10" fill="#FFFFFF"/><rect y="20" width="60" height="10" fill="#138808"/><circle cx="30" cy="15" r="3.2" fill="none" stroke="#000080" stroke-width="0.9"/><circle cx="30" cy="15" r="0.7" fill="#000080"/></svg>';
  var LANGMETA = {
    en: { label: 'EN', name: 'English',   flag: FLAG_EN },
    sv: { label: 'SV', name: 'Svenska',   flag: FLAG_SV },
    es: { label: 'ES', name: 'Español',   flag: FLAG_ES },
    fr: { label: 'FR', name: 'Français',  flag: FLAG_FR },
    it: { label: 'IT', name: 'Italiano',  flag: FLAG_IT },
    de: { label: 'DE', name: 'Deutsch',   flag: FLAG_DE },
    pt: { label: 'PT', name: 'Português', flag: FLAG_PT },
    ru: { label: 'RU', name: 'Русский',   flag: FLAG_RU },
    hi: { label: 'HI', name: 'हिन्दी',      flag: FLAG_HI }
  };

  // Build a fresh dropdown DOM element.
  function makeDropdown() {
    var dd = document.createElement('div');
    dd.className = 'lang-dd';
    dd.setAttribute('data-lang-dd', '');
    dd.innerHTML =
      '<button type="button" class="lang-dd-trigger" aria-haspopup="listbox" aria-expanded="false" aria-label="Language / Språk / Idioma">' +
        '<span class="lang-flag" data-lang-flag></span>' +
        '<span data-lang-label>EN</span>' +
        '<svg class="lang-dd-caret" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4.5 6 8l3-3.5"/></svg>' +
      '</button>' +
      '<ul class="lang-dd-menu" role="listbox">' +
        '<li role="option"><button type="button" data-lang-btn="en"><span class="lang-flag">' + FLAG_EN + '</span>English</button></li>' +
        '<li role="option"><button type="button" data-lang-btn="sv"><span class="lang-flag">' + FLAG_SV + '</span>Svenska</button></li>' +
        '<li role="option"><button type="button" data-lang-btn="es"><span class="lang-flag">' + FLAG_ES + '</span>Español</button></li>' +
        '<li role="option"><button type="button" data-lang-btn="fr"><span class="lang-flag">' + FLAG_FR + '</span>Français</button></li>' +
        '<li role="option"><button type="button" data-lang-btn="it"><span class="lang-flag">' + FLAG_IT + '</span>Italiano</button></li>' +
        '<li role="option"><button type="button" data-lang-btn="de"><span class="lang-flag">' + FLAG_DE + '</span>Deutsch</button></li>' +
        '<li role="option"><button type="button" data-lang-btn="pt"><span class="lang-flag">' + FLAG_PT + '</span>Português</button></li>' +
        '<li role="option"><button type="button" data-lang-btn="ru"><span class="lang-flag">' + FLAG_RU + '</span>Русский</button></li>' +
        '<li role="option"><button type="button" data-lang-btn="hi"><span class="lang-flag">' + FLAG_HI + '</span>हिन्दी</button></li>' +
      '</ul>';
    return dd;
  }

  // Inject dropdown(s) so pages need no switcher markup. Mounts into any
  // [data-lang-mount] placeholders (e.g. mobile drawer) AND into the main
  // <nav>. Idempotent. The flag is hidden on the trigger via CSS — flags
  // only appear inside the dropdown menu when picking.
  function buildDropdown() {
    var anyMount = false;
    var mounts = document.querySelectorAll('[data-lang-mount]');
    for (var i = 0; i < mounts.length; i++) {
      if (!mounts[i].querySelector('.lang-dd')) {
        mounts[i].appendChild(makeDropdown());
      }
      anyMount = true;
    }
    if (anyMount) document.documentElement.setAttribute('data-td-lang-mounted', '');

    var nav = document.querySelector('nav');
    if (!nav || nav.querySelector('.lang-dd')) return;
    var dd = makeDropdown();
    // The cart script wraps the nav's right side in .tc-nav-right (Try Us Out
    // + cart icon). Putting the dropdown INSIDE that group keeps it visually
    // bundled with the right-side actions, so the centered nav-links don't
    // get pushed off balance by an extra space-between flex slot.
    var rightGroup = nav.querySelector('.tc-nav-right');
    var shop = nav.querySelector('.nav-shop');
    if (rightGroup) {
      rightGroup.insertBefore(dd, rightGroup.firstChild);
    } else if (shop && shop.parentNode) {
      shop.parentNode.insertBefore(dd, shop);
    } else {
      nav.appendChild(dd);
    }
  }

  function supported(l) { return SUPPORTED.indexOf(l) > -1; }

  // Inject the language-dropdown styles once, so every page only needs the
  // markup + script tags. Uses the brand palette with safe fallbacks.
  function injectStyles() {
    if (document.getElementById('td-i18n-style')) return;
    var css =
      '.lang-dd{position:relative;margin:0 16px 0 6px}' +
      '.lang-dd-trigger{display:flex;align-items:center;gap:5px;background:none;border:0;cursor:pointer;padding:6px 2px;font-family:inherit;font-size:12px;font-weight:500;letter-spacing:.18em;text-transform:uppercase;color:var(--espresso,#3A2E22);line-height:1;opacity:.7;transition:opacity .25s}' +
      '.lang-dd-trigger:hover{opacity:1}' +
      /* Flag is hidden on the trigger by default (kept calm); flags only show inside the dropdown menu when picking. */
      '.lang-dd-trigger .lang-flag{display:none}' +
      '.lang-flag{width:19px;height:13px;border-radius:1.5px;overflow:hidden;display:block;flex-shrink:0;box-shadow:0 0 0 .5px rgba(58,46,34,.2)}' +
      '.lang-flag svg{display:block;width:100%;height:100%}' +
      '.lang-dd-caret{width:9px;height:9px;opacity:.5;transition:transform .28s ease}' +
      '.lang-dd.open .lang-dd-caret{transform:rotate(180deg)}' +
      '.lang-dd-menu{position:absolute;top:calc(100% + 9px);right:0;min-width:150px;background:var(--cream,#F7F4EF);border:1px solid rgba(122,104,82,.22);box-shadow:0 14px 34px rgba(42,32,24,.16);border-radius:4px;padding:5px;list-style:none;margin:0;opacity:0;visibility:hidden;transform:translateY(-6px);transition:opacity .2s,transform .2s,visibility .2s;z-index:1200}' +
      '.lang-dd.open .lang-dd-menu{opacity:1;visibility:visible;transform:translateY(0)}' +
      '.lang-dd-menu li{display:block}' +
      '.lang-dd-menu button{display:flex;align-items:center;gap:10px;width:100%;background:none;border:0;cursor:pointer;padding:9px 11px;font-family:inherit;font-size:13px;font-weight:400;letter-spacing:.03em;text-transform:none;color:var(--espresso,#3A2E22);border-radius:3px;transition:background .18s}' +
      '.lang-dd-menu button:hover{background:rgba(122,104,82,.10)}' +
      '.lang-dd-menu button.is-active{background:rgba(122,104,82,.14);font-weight:500}' +
      '@media (max-width:760px){.lang-dd{margin:0 8px 0 2px}.lang-dd-trigger{font-size:11px;gap:5px}}' +
      /* When the dropdown sits inside the cart wrapper (.tc-nav-right), drop its outer margin so the group stays tight; small right gap keeps the dropdown from kissing Try Us Out. */
      '.tc-nav-right .lang-dd{margin:0 14px 0 0}' +
      /* When a drawer mount exists (mobile drawer), hide the nav top-bar dropdown on mobile/tablet so the switcher lives inside the hamburger instead. Uses 980px to match the hamburger-visible breakpoint, and descendant selector since the dropdown now lives inside .tc-nav-right rather than as a direct nav child. */
      '@media (max-width:980px){html[data-td-lang-mounted] nav .lang-dd{display:none}}' +
      /* Drawer-mounted dropdown: bigger, calmer placement inside the mobile drawer. */
      '.mobile-drawer-lang{padding:18px 24px;border-top:1px solid rgba(122,104,82,.18)}' +
      '[data-lang-mount] .lang-dd{margin:0}' +
      '[data-lang-mount] .lang-dd-trigger{font-size:13px;opacity:1;letter-spacing:.22em;padding:6px 0}' +
      '[data-lang-mount] .lang-dd-menu{right:auto;left:0;min-width:170px;top:auto;bottom:calc(100% + 8px)}' +
      '[data-lang-mount] .lang-dd.open .lang-dd-menu{transform:translateY(0)}';
    var s = document.createElement('style');
    s.id = 'td-i18n-style';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function detect() {
    // 1. explicit saved choice
    try {
      var saved = localStorage.getItem(STORE_KEY);
      if (supported(saved)) return saved;
    } catch (e) {}

    // 2. URL signal
    var host = (location.hostname || '').toLowerCase();
    if (/\.se$/.test(host)) return 'sv';
    if (/\.es$/.test(host)) return 'es';
    if (/\.fr$/.test(host)) return 'fr';
    if (/\.it$/.test(host)) return 'it';
    if (/\.de$/.test(host)) return 'de';
    // Brazilian Portuguese is our pt variant; both .br and .pt route to it.
    if (/\.br$/.test(host)) return 'pt';
    if (/\.pt$/.test(host)) return 'pt';
    if (/\.ru$/.test(host)) return 'ru';
    if (/\.in$/.test(host)) return 'hi';
    try {
      var qp = new URLSearchParams(location.search).get('lang');
      if (supported(qp)) return qp;
    } catch (e) {}
    if (/(^|\/)sv(\/|$)/.test(location.pathname)) return 'sv';
    if (/(^|\/)es(\/|$)/.test(location.pathname)) return 'es';
    if (/(^|\/)fr(\/|$)/.test(location.pathname)) return 'fr';
    if (/(^|\/)it(\/|$)/.test(location.pathname)) return 'it';
    if (/(^|\/)de(\/|$)/.test(location.pathname)) return 'de';
    if (/(^|\/)pt(\/|$)/.test(location.pathname)) return 'pt';
    if (/(^|\/)ru(\/|$)/.test(location.pathname)) return 'ru';
    if (/(^|\/)hi(\/|$)/.test(location.pathname)) return 'hi';

    // 3. browser language
    var nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
    if (nav.indexOf('sv') === 0) return 'sv';
    if (nav.indexOf('es') === 0) return 'es';
    if (nav.indexOf('fr') === 0) return 'fr';
    if (nav.indexOf('it') === 0) return 'it';
    if (nav.indexOf('de') === 0) return 'de';
    if (nav.indexOf('pt') === 0) return 'pt';
    if (nav.indexOf('ru') === 0) return 'ru';
    if (nav.indexOf('hi') === 0) return 'hi';

    // 4. default
    return DEFAULT;
  }

  function translate(key, lang) {
    var table = DICT[lang];
    if (table && Object.prototype.hasOwnProperty.call(table, key)) return table[key];
    return null; // fall back to English already in the DOM
  }

  function apply(lang) {
    if (!supported(lang)) lang = DEFAULT;
    document.documentElement.lang = lang;

    // text / HTML content
    var nodes = document.querySelectorAll('[data-i18n]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var key = el.getAttribute('data-i18n');
      // cache the original English HTML once
      if (!el.hasAttribute('data-i18n-en')) el.setAttribute('data-i18n-en', el.innerHTML);
      if (lang === 'en') {
        el.innerHTML = el.getAttribute('data-i18n-en');
      } else {
        var t = translate(key, lang);
        el.innerHTML = (t != null) ? t : el.getAttribute('data-i18n-en');
      }
    }

    // attributes (placeholder, aria-label, title, alt, content...)
    var attrNodes = document.querySelectorAll('[data-i18n-attr]');
    for (var j = 0; j < attrNodes.length; j++) {
      var node = attrNodes[j];
      var pairs = node.getAttribute('data-i18n-attr').split(';');
      for (var k = 0; k < pairs.length; k++) {
        var pair = pairs[k].trim();
        if (!pair) continue;
        var idx = pair.indexOf(':');
        if (idx < 0) continue;
        var attr = pair.slice(0, idx).trim();
        var akey = pair.slice(idx + 1).trim();
        var cacheAttr = 'data-i18n-en-' + attr;
        if (!node.hasAttribute(cacheAttr)) node.setAttribute(cacheAttr, node.getAttribute(attr) || '');
        if (lang === 'en') {
          node.setAttribute(attr, node.getAttribute(cacheAttr));
        } else {
          var at = translate(akey, lang);
          node.setAttribute(attr, (at != null) ? at : node.getAttribute(cacheAttr));
        }
      }
    }

    // reflect state on any language toggles
    var btns = document.querySelectorAll('[data-lang-btn]');
    for (var m = 0; m < btns.length; m++) {
      var on = btns[m].getAttribute('data-lang-btn') === lang;
      btns[m].classList.toggle('is-active', on);
      btns[m].setAttribute('aria-selected', on ? 'true' : 'false');
    }

    // update dropdown trigger label + flag
    var meta = LANGMETA[lang] || LANGMETA[DEFAULT];
    var labelEls = document.querySelectorAll('[data-lang-label]');
    for (var n = 0; n < labelEls.length; n++) labelEls[n].textContent = meta.label;
    var flagEls = document.querySelectorAll('[data-lang-flag]');
    for (var p = 0; p < flagEls.length; p++) flagEls[p].innerHTML = meta.flag;

    try { localStorage.setItem(STORE_KEY, lang); } catch (e) {}
    document.documentElement.setAttribute('data-td-lang', lang);

    // Browser-translate guard: when we're actively showing a localized
    // language (sv/es/fr/it/de/pt/ru/hi), tell browsers not to layer their
    // own auto-translation on top (which produces false-cognate mistakes
    // such as Spanish "conservantes" being rendered as English
    // "conservatives", or Portuguese "preservativos" likewise). For EN,
    // allow browser translation so visitors whose language we don't
    // support (e.g. Japanese, Korean) still get an option.
    var existingMeta = document.querySelector('meta[name="google"][content*="notranslate"]');
    if (lang === DEFAULT) {
      if (existingMeta) existingMeta.parentNode.removeChild(existingMeta);
      document.documentElement.classList.remove('notranslate');
      document.body && document.body.classList.remove('notranslate');
    } else {
      if (!existingMeta) {
        var m = document.createElement('meta');
        m.setAttribute('name', 'google');
        m.setAttribute('content', 'notranslate');
        (document.head || document.documentElement).appendChild(m);
      }
      document.documentElement.classList.add('notranslate');
      document.body && document.body.classList.add('notranslate');
    }
  }

  // public: TDsetLang('sv')
  window.TDsetLang = function (lang) { if (supported(lang)) apply(lang); };
  window.TDgetLang = function () { try { return localStorage.getItem(STORE_KEY) || detect(); } catch (e) { return detect(); } };

  function closeAllDropdowns(except) {
    var dds = document.querySelectorAll('[data-lang-dd].open');
    for (var i = 0; i < dds.length; i++) {
      if (dds[i] === except) continue;
      dds[i].classList.remove('open');
      var trig = dds[i].querySelector('.lang-dd-trigger');
      if (trig) trig.setAttribute('aria-expanded', 'false');
    }
  }

  function init() {
    injectStyles();
    try { buildDropdown(); } catch (e) {}
    apply(detect());

    document.addEventListener('click', function (e) {
      var t = e.target;

      // toggle the dropdown open/closed
      var trigger = t.closest && t.closest('.lang-dd-trigger');
      if (trigger) {
        e.preventDefault();
        var dd = trigger.closest('[data-lang-dd]');
        var willOpen = !dd.classList.contains('open');
        closeAllDropdowns(dd);
        dd.classList.toggle('open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }

      // pick a language
      var btn = t.closest && t.closest('[data-lang-btn]');
      if (btn) {
        e.preventDefault();
        apply(btn.getAttribute('data-lang-btn'));
        closeAllDropdowns(null);
        return;
      }

      // click outside closes
      closeAllDropdowns(null);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDropdowns(null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
